import { render, staticRenderFns } from "./LoadingSpinnerIcon.vue?vue&type=template&id=05cdc7fe"
import script from "./LoadingSpinnerIcon.vue?vue&type=script&lang=js"
export * from "./LoadingSpinnerIcon.vue?vue&type=script&lang=js"
import style0 from "./LoadingSpinnerIcon.vue?vue&type=style&index=0&id=05cdc7fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports